module.exports = __webpack_public_path__ + "img/ac4af4f.jpg";